import { URL } from '../../constants';

function getImage(file) {
    return file?.gatsbyImageData?.images?.fallback?.src
        ? file.gatsbyImageData?.images?.fallback?.src
        : null;
}

export default function useSchema(
    type: 'page' | 'article' | 'job' | 'faq' = 'page',
    pageData: any = {},
    extraContent: any = null,
) {
    const organization = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: URL,
        name: 'Soluble',
        logo: {
            '@type': 'ImageObject',
            url: `${URL}assets/logo.png`,
        },
    };

    let schema = {};

    if (type === 'page') {
        schema = {
            ...organization,
        };
    }

    if (type === 'article') {
        schema = {
            '@context': 'https://schema.org',
            '@type': 'BlogPosting',
            headline: pageData?.title || '',
            description:
                pageData?.metaDescription || pageData?.description || '',
            image: getImage(pageData?.metaImage?.file),
            datePublished: pageData?.publishedAt || pageData?.createdAt,
            dateModified: pageData?.updatedAt,
            author: pageData?.authorRoles?.length
                ? pageData.authorRoles.map((ar) => ({
                      '@type': 'Person',
                      name: ar?.person?.name,
                      ...(!!ar?.person?.role && { jobTitle: ar?.person?.role }),
                      url: ar?.person?.link,
                  }))
                : [organization],
            publisher: organization,
            inLanguage: pageData?.locale,
            ...(!!pageData?.url && {
                url: pageData?.url,
            }),
            // TODO
            // speakable: {
            //     '@type': 'SpeakableSpecification',
            //     cssSelector: ['.headline', '.summary'],
            // },
        };
    }

    if (type === 'job') {
        const date = pageData?.createdAt
            ? new Date(pageData?.createdAt)
            : new Date();

        schema = {
            '@context': 'https://schema.org/',
            '@type': 'JobPosting',
            title: pageData?.title || '',
            validThrough: new Date(
                date.setMonth(date.getMonth() + 1),
            ).toISOString(),
            description:
                pageData?.description || pageData?.metaDescription || '',
            identifier: {
                '@type': 'PropertyValue',
                name: 'Soluble',
            },
            datePosted: pageData?.createdAt,
            employmentType: 'FULL_TIME',
            hiringOrganization: organization,
            jobLocationType: 'TELECOMMUTE',
            salaryCurrency: 'EUR',
            baseSalary: {
                '@type': 'MonetaryAmount',
                currency: 'EUR',
                value: {
                    '@type': 'Number',
                    value: pageData?.baseSalary,
                    unitText: 'YEAR',
                },
            },
            applicantLocationRequirements: {
                '@type': 'Country',
                name: 'SPAIN',
            },
        };
    }

    if (type === 'faq') {
        schema = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity:
                pageData?.faqs?.length > 0
                    ? pageData.faqs.map((faq: any) => ({
                          '@type': 'Question',
                          name: faq?.title,
                          acceptedAnswer: {
                              '@type': 'Answer',
                              text: faq?.body,
                          },
                      }))
                    : [],
        };
    }

    if (extraContent) {
        schema = { ...schema, ...extraContent };
    }

    return schema;
}
